// src/lib/richtext/htmlSanitizer.js
import DOMPurify from 'dompurify'

/**
 * Sanitize HTML content to prevent XSS attacks
 * @param {string} html - HTML string to sanitize
 * @returns {string} Sanitized HTML string
 */
export const sanitizeHtml = (html) => {
  try {
    if (!html) return ''
    
    // Configure DOMPurify with safe defaults
    const config = {
      USE_PROFILES: { html: true },
      ALLOWED_TAGS: [
        'p', 'br', 'strong', 'b', 'em', 'i', 'u', 's', 'strike',
        'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
        'ul', 'ol', 'li',
        'blockquote', 'pre', 'code',
        'a', 'span', 'div',
        'mark' // for highlight
      ],
      ALLOWED_ATTR: [
        'href', 'target', 'rel', 'title',
        'style', 'class',
        'data-*'
      ],
      ALLOWED_URI_REGEXP: /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|cid|xmpp):|[^a-z]|[a-z+.-]+(?:[^a-z+.-:]|$))/i,
      ALLOW_DATA_ATTR: true,
      KEEP_CONTENT: true,
      RETURN_DOM: false,
      RETURN_DOM_FRAGMENT: false,
      RETURN_DOM_IMPORT: false,
      SANITIZE_DOM: true,
      FORCE_BODY: false,
      SANITIZE_NAMED_PROPS: false,
      ALLOW_UNKNOWN_PROTOCOLS: false,
      ALLOW_SELF_CLOSE_IN_ATTR: true,
      CUSTOM_ELEMENT_HANDLING: {
        tagNameCheck: null,
        attributeNameCheck: null,
        allowCustomizedBuiltInElements: false,
      }
    }
    
    return DOMPurify.sanitize(html, config)
  } catch (error) {
    console.warn('Failed to sanitize HTML:', error)
    return ''
  }
}

/**
 * Sanitize HTML for display in viewer (more restrictive)
 * @param {string} html - HTML string to sanitize
 * @returns {string} Sanitized HTML string
 */
export const sanitizeHtmlForViewer = (html) => {
  try {
    if (!html) return ''
    
    // More restrictive config for viewer
    const config = {
      USE_PROFILES: { html: true },
      ALLOWED_TAGS: [
        'p', 'br', 'strong', 'b', 'em', 'i', 'u', 's', 'strike',
        'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
        'ul', 'ol', 'li',
        'blockquote', 'pre', 'code',
        'a', 'span',
        'mark' // for highlight
      ],
      ALLOWED_ATTR: [
        'href', 'target', 'rel',
        'style', 'class'
      ],
      ALLOWED_URI_REGEXP: /^(?:(?:(?:f|ht)tps?|mailto|tel):|[^a-z]|[a-z+.-]+(?:[^a-z+.-:]|$))/i,
      KEEP_CONTENT: true,
      RETURN_DOM: false,
      SANITIZE_DOM: true,
      FORCE_BODY: false
    }
    
    return DOMPurify.sanitize(html, config)
  } catch (error) {
    console.warn('Failed to sanitize HTML for viewer:', error)
    return ''
  }
}